import React from 'react'
import useUrlSearchParams from '../../hooks/useUrlSearchParams'
import usePairedCompetitions from '../../hooks/usePairedCompetitions'
import UnauthorizedPage from '../Unauthorized/UnauthorizedPage'
import UNAUTHORIZED_REASONS from '../../utils/constants/unauthorizedReasons'
import CmsAdminPage from '../CmsAdminPage/CmsAdminPage'

// The federation competition a club team is paired into, read-only: the federation's own CMS
// screens, scoped by the URL (?fedOrg & ?competition, see useCmsScope). The route guard cannot
// require the club's ViewStats (it admits on any org add-on), so the page checks the competition
// is one the club side lists for this caller; the federation's routes refuse anything else.
const PairedCmsPage = () => {
  const { org, team, fedOrg, competition } = useUrlSearchParams(['org', 'team', 'fedOrg', 'competition']) || {}
  const { data: competitions, isLoading } = usePairedCompetitions(org, team)

  if (isLoading) return null

  const listed = (competitions || []).some((c) => c.competitionId === competition && c.fedOrgId === fedOrg)
  if (!listed) return <UnauthorizedPage reason={UNAUTHORIZED_REASONS.ACCESS} />

  return <CmsAdminPage />
}

export default PairedCmsPage
